interface LiveIndicatorProps {
  label?: string;
  pulse?: boolean;
  size?: 'sm' | 'md';
}

export default function LiveIndicator({
  label = 'Live',
  pulse = true,
  size = 'sm',
}: LiveIndicatorProps) {
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';
  const textSize = size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 bg-green-50 text-green-700 rounded-full ${textSize} font-medium`}>
      <span className="relative flex">
        <span className={`${dotSize} bg-green-500 rounded-full`} />
        {pulse && (
          <span className={`absolute inset-0 ${dotSize} bg-green-400 rounded-full animate-ping`} />
        )}
      </span>
      {label}
    </span>
  );
}
